export default __webpack_public_path__ + "static/media/goBack.33effd51.svg";